import { computed } from 'vue';
import ConversationApi from '../api/inbox/conversation';

export function useCustomAttributes(store) {
  /**
   * Fetches custom attributes for a conversation if they don't exist in the store
   * @param {number} conversationId - The ID of the conversation
   * @returns {Promise<Object>} - The custom attributes object
   */
  const fetchCustomAttributesIfNeeded = async conversationId => {
    let customAttributesData =
      store.getters.getConversationCustomAttributesData(conversationId);

    if (!customAttributesData) {
      try {
        const response = await ConversationApi.getConversation(conversationId);

        if (response.data && response.data.custom_attributes) {
          customAttributesData = response.data.custom_attributes;

          store.dispatch('setConversationCustomAttributesData', {
            conversationId,
            customAttributesData,
          });
        } else {
          customAttributesData = {};
          store.dispatch('setConversationCustomAttributesData', {
            conversationId,
            customAttributesData,
          });
        }
      } catch (error) {
        customAttributesData = {};
      }
    }

    return customAttributesData;
  };

  /**
   * Creates a computed property that returns custom attributes for a conversation
   * @param {ComputedRef<number>} conversationId - Computed ref containing the conversation ID
   * @returns {ComputedRef<Object>} - Computed ref containing the custom attributes
   */
  const getCustomAttributes = conversationId => {
    return computed(
      () =>
        store.getters.getConversationCustomAttributesData(
          conversationId.value
        ) || {}
    );
  };

  return {
    fetchCustomAttributesIfNeeded,
    getCustomAttributes,
  };
}
